(() => {
  const desktopMotion = window.matchMedia('(min-width: 990px) and (prefers-reduced-motion: no-preference)');

  class ArticleFloat {
    constructor(root) {
      this.root = root;
      this.card = root.querySelector('.op-article__aside--floating .op-article__cta');
      this.strength = Math.max(0, Number(root.dataset.opFloatStrength) || 0);
      this.current = 0;
      this.target = 0;
      this.lastScrollY = window.scrollY;
      this.frame = null;
      this.onScroll = this.onScroll.bind(this);
      this.animate = this.animate.bind(this);

      if (this.card && this.strength > 0) {
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }
    }

    onScroll() {
      const nextScrollY = window.scrollY;
      const delta = nextScrollY - this.lastScrollY;
      this.lastScrollY = nextScrollY;

      if (!desktopMotion.matches) {
        this.reset();
        return;
      }

      this.target = Math.max(-this.strength, Math.min(this.strength, this.target + delta * 0.08));

      if (!this.frame) {
        this.frame = window.requestAnimationFrame(this.animate);
      }
    }

    animate() {
      this.current += (this.target - this.current) * 0.14;
      this.target *= 0.86;
      this.card.style.setProperty('--op-article-float-offset', `${this.current.toFixed(2)}px`);

      if (Math.abs(this.current) > 0.08 || Math.abs(this.target) > 0.08) {
        this.frame = window.requestAnimationFrame(this.animate);
        return;
      }

      this.reset();
    }

    reset() {
      if (this.frame) {
        window.cancelAnimationFrame(this.frame);
      }
      this.frame = null;
      this.current = 0;
      this.target = 0;
      this.card.style.setProperty('--op-article-float-offset', '0px');
    }

    destroy() {
      window.removeEventListener('scroll', this.onScroll);
      this.reset();
      delete this.root.articleFloat;
    }
  }

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-op-article-float]').forEach((root) => {
      if (!root.articleFloat) {
        root.articleFloat = new ArticleFloat(root);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-op-article-float]').forEach((root) => root.articleFloat?.destroy());
  });
})();
